export default __webpack_public_path__ + "static/media/TF-Portfolio-page.6b956e48.png";